import Immutable from 'immutable';
import { PageId } from 'records/Page';

export interface RawPageReadyForReview {
  filename: string;
  pageid: PageId;
  documentid: string;
  projectid: string;
  pageLabel: string; // Inferred sheet number
  pageIndex: number;
  documentTitle: string; // Inferred sheet title
  width: number;
  height: number;
  // signedThumbnailUrl: string; // Saving as a reminder.
  inferredDisciplineDesignator: string;
  inferredPrimaryDiscipline: string;
  inferredSecondaryDiscipline: string;
  inferredsheetnumber: string;
  inferredsheettitle: string;
}

export interface PageReadyForReviewData {
  filename: string;
  pageid: PageId;
  documentid: string;
  projectid: string;
  pageLabel: string; // Inferred sheet number
  pageIndex: number;
  documentTitle: string; // Inferred sheet title
  width: number;
  height: number;
  // signedThumbnailUrl: string;
  inferredDisciplineDesignator: string;
  inferredPrimaryDiscipline: string;
  inferredSecondaryDiscipline: string;
  inferredsheetnumber: string;
  inferredsheettitle: string;
}

const defaultValues: PageReadyForReviewData = {
  filename: '',
  pageid: '',
  documentid: '',
  projectid: '',
  pageLabel: '',
  pageIndex: 0,
  documentTitle: '',
  width: 1,
  height: 1,
  // signedThumbnailUrl: '',
  inferredDisciplineDesignator: '',
  inferredPrimaryDiscipline: '',
  inferredSecondaryDiscipline: '',
  inferredsheetnumber: '',
  inferredsheettitle: '',
};

export const PageReadyForReviewFactory = Immutable.Record(
  defaultValues,
  'PageReadyForReview'
);

export class PageReadyForReview extends PageReadyForReviewFactory {
  static deserialize(
    rawPageReadyForReview: RawPageReadyForReview
  ): PageReadyForReview {
    return new PageReadyForReview({
      ...rawPageReadyForReview,
    });
  }

  serialize(): RawPageReadyForReview {
    return this.toJS();
  }
}

export type PageReadyForReviewList = Immutable.List<PageReadyForReview>;

export type PageReadyForReviewMap = Immutable.OrderedMap<
  PageId,
  PageReadyForReview
>;
